import React from 'react'
import FindingPurposePageOne from './FindingPurposePageOne'
import FindingPurposePageTwo from './FindingPurposePageTwo'
import FindingPurposePageThree from './FindingPurposePageThree'

const FindingPurposeExercise = ({ section }) => {
  return (
    <div>
      {section === 0 && <FindingPurposePageOne />}
      {section === 1 && <FindingPurposePageTwo />}
      {section === 2 && <FindingPurposePageThree />}
    </div>
  )
}

export default FindingPurposeExercise
